import React from 'react';

const LoadingSpinner: React.FC<{ label?: string }> = ({ label }) => (
  <div className="flex w-full justify-center items-center" role="status" aria-live="polite" style={{ minHeight: 200 }}>
    <div className="flex flex-col items-center gap-3">
      <div className="relative h-9 w-9">
        <div className="absolute inset-0 rounded-full border-2 border-muted" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-primary animate-spin" />
      </div>
      {label ? <div className="text-sm text-muted-foreground animate-fade-in">{label}</div> : null}
    </div>
  </div>
);

export default LoadingSpinner;
